export const PATIENT_STATUSES = [
    "active",
    "archived",
];
export function isPatientStatus(value) {
    return PATIENT_STATUSES.includes(value);
}
/** Any status the API sends, read as one of the two: "inactive" is Archived, the rest Active */
export function normalizePatientStatus(value) {
    const normalized = (value !== null && value !== void 0 ? value : "").trim().toLowerCase();
    return normalized === "archived" || normalized === "inactive"
        ? "archived"
        : "active";
}
